import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@material-ui/core";
import React from "react";

const OrcamentoExtras = (props) => {
	return (
		<React.Fragment>
			<div className="p-1">
				<FormControl fullWidth className="mb-1">
					<InputLabel>Validade</InputLabel>
					<Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						value={props.orcamentoExtras.expirationDays}
						onChange={(e) =>
							props.SetOrcamentoExtras({
								...props.orcamentoExtras,
								expirationDays: e.target.value,
							})
						}
					>
						{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((item) => {
							return (
								<MenuItem key={item} value={item}>
									{item} {item === 1 ? "dia" : "dias"}
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
				<FormControl fullWidth className="mb-1">
					<TextField
						label="Observações"
						autoComplete={"off"}
						helperText={
							"Observações para o cliente, aparece no PDF do orçamento."
						}
						value={
							props.orcamentoExtras.comments !== null
								? props.orcamentoExtras.comments
								: ""
						}
						onChange={(e) =>
							props.SetOrcamentoExtras({
								...props.orcamentoExtras,
								comments: e.target.value,
							})
						}
						multiline
					/>
				</FormControl>
			</div>
		</React.Fragment>
	);
};

export default OrcamentoExtras;
